import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Trade delivery'

  }
];

@Component({
  selector: 'page-trade-delivery-detail',
  templateUrl: './trade-delivery-detail.html',
  styleUrls: ['./trade-delivery-detail.scss']
})

export class PageTradeDeliveryDetail implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  customerCtrl: FormControl;
  fetchCustomer=[];
  filteredCustomers: any;
  customers = [];
  rows = [];
  temp = [];
  model=[];

  key:any="";keypart:any="";
  productCtrl:FormControl;
  productModels=[];
  filteredProducts:any;
  loadingIndicator: boolean = true;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/product-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/product-list-export.php";
  dateFilter:boolean=false;
  date_selected:any;
  constructor(private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    let date = new Date();
    this.date_selected = date.toISOString().split('T')[0];
    this.getCustomer();
    this.getProduct();
    this.getStartData();
   // console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);
  }

  getStartData(){
    this.httpservice.fetchget('getJSON_product.php?keypart='+this.keypart+'&key='+this.key,(data)=>{
      this.temp = [...data];
      this.rows = data;
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
});
  }

  onlyDatefilter(e){
    if(e.checked){
      this.dateFilter = true;
    }else{
      this.dateFilter = false;
    }
  }
  getCustomer(){
    this.httpservice.fetchget('getJSON_customer_name.php?',(data)=>{
      this.customers = data.map(function (val) {
        return [val.tc_company_shortname]
      });
    });


    this.customerCtrl = new FormControl();
    this.filteredCustomers = this.customerCtrl.valueChanges
    .startWith(null)
    .map(val=>{
      if(isArray(val)){
        this.key=val[0];
      }else{
        this.key=val;
      }
     
      return val ? this.customers.filter((s) => new RegExp(val, 'gi').test(s)) : this.customers;
    });
    
  }

  getProduct(){
    this.httpservice.fetchget('getJSON_product.php?',(productModel) => {
      this.productModels = productModel.map(function (val) {
        return [val.tp_part_no]
      });
      console.log('------this.product------', this.productModels);
    });
    this.productCtrl = new FormControl();
    this.filteredProducts = this.productCtrl.valueChanges
    .startWith(null)
    .map(val => {

      if (isArray(val)) {
        this.keypart = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.keypart = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.productModels.filter((s) => new RegExp(val, 'gi').test(s)) : this.productModels;
    });
  }



  disableProduct(tp_id:string){
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/disableProduct.php?tp_id='+tp_id);
    req.onload = () => {
      console.log('---delect status ---',JSON.parse(req.response),tp_id);
      //JSON.parse(req.response);
    };
    req.send();
    for(let i=0;i<2;i++){
      this.search();
    }
  }
  edit(tp_id:string){
    console.log('----ID----',tp_id);
    this.router.navigateByUrl('default-layout/product-form-edit/'+tp_id);
  }

  fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_product.php?key='+this.key[0]);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

search(){ 
  this.httpservice.fetchget('getJSON_product.php?keypart='+this.keypart+'&key='+this.key,(data)=>{
          this.temp = [...data];
          this.rows = data;
          setTimeout(() => { this.loadingIndicator = false; }, 1500);
  });
  this.productCtrl.reset();
  this.customerCtrl.reset();
  this.key="";
  this.keypart="";
  }

  ngOnInit() {


  }



    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      
      return d.tp_part_no.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/trade-back/trade-delivery-detail.ts